import axios from 'axios';
import { ApiError } from './createClient';
import { MARKET_API } from '../constants/endpoints';

const marketClient = axios.create({
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

marketClient.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (!body || typeof body.code !== 'number') {
      return response.data;
    }
    if (body.code !== 200) {
      throw new ApiError(body.message || '請求失敗', body.code, body);
    }
    return body.data;
  },
  (error) => {
    const payload = error.response?.data;
    const message =
      payload?.message || payload?.mes || error.message || '網路請求失敗';
    return Promise.reject(new ApiError(message, payload?.code, payload));
  }
);

export const marketApi = {
  listSymbols: () => marketClient.get(`${MARKET_API}/symbols`),

  getThumb: (code) => marketClient.get(`${MARKET_API}/thumb/${encodeURIComponent(code)}`),

  getLatestOhlcv: (symbol, limit = 30) =>
    marketClient.get(`${MARKET_API}/ohlcv/latest`, {
      params: { symbol, limit },
    }),

  getHistoricalOhlcv: (symbol, startTime, endTime) =>
    marketClient.get(`${MARKET_API}/ohlcv/historical`, {
      params: { symbol, startTime, endTime },
    }),
};
